const daysUntil = (d) => { if (!d) return null; return Math.ceil((new Date(d)-new Date())/86400000) }

export function ClientBadges({ client }) {
  const days = daysUntil(client.renewal_date)
  return (
    <div style={{display:'flex',gap:3,flexWrap:'wrap',marginTop:3}}>
      {client.referring_partner && <span className="badge badge-purple">Referral</span>}
      {client.lead_status==='Awaiting Client' && <span className="badge badge-warn">Awaiting Client</span>}
      {!client.phone && <span className="badge badge-red">No Phone</span>}
      {!client.email && <span className="badge badge-grey">No Email</span>}
      {days!==null && days<=30 && days>0 && <span className="badge badge-red">Renewal Due</span>}
    </div>
  )
}
